import { useSettings } from '@backpackjs/storefront';
import Script from 'next/script';

export function BeamCumulativeImpactWrapper() {
  const settings = useSettings();
  const beamSettings = settings?.beam;

  if (!beamSettings) return null;

  return (
    <>
      <Script
        strategy="afterInteractive"
        type="module"
        crossOrigin="anonymous"
        src="https://sdk.beamimpact.com/web-sdk/v1.53.1/dist/components/cumulative-impact.esm.js"
      />
      <beam-cumulative-impact
        apiKey={beamSettings.beamApiKey}
        chainId={beamSettings.beamChainId}
        storeId={beamSettings.beamStoreId}
        baseUrl="https://api.beamimpact.com"
        lang="en"
      />
    </>
  );
}
